// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Content from "./content.js"

const modelClassData = {
  "attributes": {
    "body": {
      "column": null,
      "name": "body",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    },
    "subject": {
      "column": null,
      "name": "subject",
      "selected_by_default": false,
      "translated": true
    },
    "subject_da": {
      "column": null,
      "name": "subject_da",
      "selected_by_default": false,
      "translated": false
    },
    "subject_en": {
      "column": null,
      "name": "subject_en",
      "selected_by_default": false,
      "translated": false
    },
    "subject_no": {
      "column": null,
      "name": "subject_no",
      "selected_by_default": false,
      "translated": false
    },
    "subject_se": {
      "column": null,
      "name": "subject_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "EmailTemplate",
  "collectionKey": "email_templates",
  "collectionName": "email_templates",
  "i18nKey": "email_template",
  "camelizedLower": "emailTemplate",
  "name": "EmailTemplate",
  "nameDasherized": "email-template",
  "pluralName": "email_templates",
  "ransackable_associations": [
    {
      "className": "EmailTemplate::Audit",
      "collectionName": "email_template_audits",
      "foreignKey": "email_template_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "EmailTemplateAudit",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "resource_id",
      "name": "body_model",
      "macro": "has_one",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "resource_id",
      "name": "contents",
      "macro": "has_many",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "EmailTemplate::Audit",
      "collectionName": "email_template_audits",
      "foreignKey": "email_template_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "EmailTemplateAudit",
      "through": null
    },
    {
      "className": "EmailTemplate::Translation",
      "collectionName": null,
      "foreignKey": "email_template_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "NewsletterTemplate",
      "collectionName": "newsletter_templates",
      "foreignKey": "email_template_id",
      "name": "newsletter_templates",
      "macro": "has_many",
      "resource_name": "NewsletterTemplate",
      "through": null
    },
    {
      "className": "NotificationTypeAction",
      "collectionName": "notification_type_actions",
      "foreignKey": "email_template_id",
      "name": "notification_type_actions",
      "macro": "has_many",
      "resource_name": "NotificationTypeAction",
      "through": null
    },
    {
      "className": "EmailTemplatePreview",
      "collectionName": "email_template_previews",
      "foreignKey": "email_template_id",
      "name": "previews",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreview",
      "through": null
    },
    {
      "className": "EmailTemplate::Translation",
      "collectionName": null,
      "foreignKey": "email_template_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "resource_id",
      "name": "contents",
      "macro": "has_many",
      "resource_name": "Content",
      "through": null
    }
  ],
  "paramKey": "email_template",
  "primaryKey": "id"
}

/** Frontend model for EmailTemplate. */
export default class EmailTemplate extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  body() {
    return this.readAttributeUnderscore("body")
  }

  /** @returns {boolean} */
  hasBody() {
    const value = this.body()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  subject() {
    return this.readAttributeUnderscore("subject")
  }

  /** @returns {boolean} */
  hasSubject() {
    const value = this.subject()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subjectDa() {
    return this.readAttributeUnderscore("subject_da")
  }

  /** @returns {boolean} */
  hasSubjectDa() {
    const value = this.subjectDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subjectEn() {
    return this.readAttributeUnderscore("subject_en")
  }

  /** @returns {boolean} */
  hasSubjectEn() {
    const value = this.subjectEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subjectNo() {
    return this.readAttributeUnderscore("subject_no")
  }

  /** @returns {boolean} */
  hasSubjectNo() {
    const value = this.subjectNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subjectSe() {
    return this.readAttributeUnderscore("subject_se")
  }

  /** @returns {boolean} */
  hasSubjectSe() {
    const value = this.subjectSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  clone(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "clone",
        primaryKey: this.primaryKey(),
        collectionName: "email_templates",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  liquidVariablesList(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "liquid_variables_list",
        primaryKey: this.primaryKey(),
        collectionName: "email_templates",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./content.js").default>} */
  contents() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "EmailTemplate"

    return new Collection(
      {
        reflectionName: "contents",
        model: this,
        modelClass: Content
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./content.js").default>>} */
  loadContents() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "EmailTemplate"

    return this._loadHasManyReflection(
      {
        reflectionName: "contents",
        model: this,
        modelClass: Content
      },
      {ransack}
    )
  }
}
